import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "datepicker-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "input-label mb-3" }, [
  /*#__PURE__*/_createTextVNode("Zatrudnienie "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
], -1)
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = {
  key: 0,
  class: "error-message"
}

import { useField } from 'vee-validate';
import NIPField from './NIPField.vue';
import EmployerCompanyName from './EmployerCompanyName.vue';
import Select from '../../ui/Select.vue';
import YourRoleInWork from './YourRoleInWork.vue';


export default {
  __name: 'SelectEmployerField',
  setup(__props) {

const { value, setValue, errorMessage } = useField('employerType');

const options = [
    {
        id: 'Pracownik - osoba cywilna',
        title: 'Pracownik - osoba cywilna',
    },
    {
        id: 'Student / uczeń',
        title: 'Student / uczeń',
    },
    {
        id: 'Pracownik służb mundurowych',
        title: 'Pracownik służb mundurowych',
    },
    {
        id: 'Pracownik w firmie zagranicznej',
        title: 'Pracownik w firmie zagranicznej',
    },
];

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Select, {
          options: options,
          selected: _unref(value),
          onOnChange: _unref(setValue)
        }, null, 8, ["selected", "onOnChange"])
      ]),
      (_unref(errorMessage))
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(errorMessage)), 1))
        : _createCommentVNode("", true)
    ]),
    (_unref(value) === 'Pracownik - osoba cywilna' || _unref(value) === 'Pracownik służb mundurowych')
      ? (_openBlock(), _createBlock(NIPField, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(value) === 'Pracownik - osoba cywilna' || _unref(value) === 'Pracownik służb mundurowych' || _unref(value) === 'Pracownik w firmie zagranicznej')
      ? (_openBlock(), _createBlock(YourRoleInWork, { key: 1 }))
      : _createCommentVNode("", true),
    (_unref(value) === 'Pracownik w firmie zagranicznej')
      ? (_openBlock(), _createBlock(EmployerCompanyName, { key: 2 }))
      : _createCommentVNode("", true),
    (_unref(value) === 'Student / uczeń')
      ? (_openBlock(), _createBlock(EmployerCompanyName, {
          key: 3,
          label: "Nazwa placówki"
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

}